import { default as RLayer } from './RLayer';
/** The common base of all tiled (even if not raster) layers, not meant to be used directly */
export default class RLayerRaster extends RLayer {
}
//# sourceMappingURL=RLayerRaster.js.map